const CHATBOT_SETTINGS_TYPES = {
  FETCH_SETTINGS_REQUEST: 'ADMIN_CHATBOT/FETCH_SETTINGS_REQUEST',
  FETCH_SETTINGS_SUCCESS: 'ADMIN_CHATBOT/FETCH_SETTINGS_SUCCESS',
  FETCH_SETTINGS_FAILURE: 'ADMIN_CHATBOT/FETCH_SETTINGS_FAILURE',

  UPDATE_SETTINGS_REQUEST: 'ADMIN_CHATBOT/UPDATE_SETTINGS_REQUEST',
  UPDATE_SETTINGS_SUCCESS: 'ADMIN_CHATBOT/UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_FAILURE: 'ADMIN_CHATBOT/UPDATE_SETTINGS_FAILURE',

  FETCH_USAGE_STATS_REQUEST: 'ADMIN_CHATBOT/FETCH_USAGE_STATS_REQUEST',
  FETCH_USAGE_STATS_SUCCESS: 'ADMIN_CHATBOT/FETCH_USAGE_STATS_SUCCESS',
  FETCH_USAGE_STATS_FAILURE: 'ADMIN_CHATBOT/FETCH_USAGE_STATS_FAILURE',

  SET_DAYS_FILTER: 'ADMIN_CHATBOT/SET_DAYS_FILTER',
};

export default CHATBOT_SETTINGS_TYPES;
